import {UserDatumForm as _UserDatumForm} from "./user-datum.form";
import {UserDatumFormButton} from "./user-datum.form.button";

export const UserDatumForm = {
    Form: _UserDatumForm,
    Button: UserDatumFormButton,
}
